import OnboardingItemEdit from '@/components/settings/onboarding/onboarding-item/edit/OnboardingItemEdit.vue';

const defaultFilterValues = {
  name: null,
  type_id: null,
  workspace_type_id: null
};

export default {
  name: 'OnboardingItemList',
  components: { OnboardingItemEdit },
  data () {
    return {
      isMounted: false,
      isLoading: false,
      paging: {
        page: 1,
        pages: 1,
        limit: 20,
        total: 0
      },
      tableSorting: { item: 'title', direction: 'asc' },
      tableItems: [],
      filterValues: {
        title: null,
        published_at: [1]
      }
    }
  },
  computed: {
    tableActions () {
      const actions = { download: false };
      return actions;
    },
    tableHeaders () {
      const headers = [
        { key: 'name.' + this.$i18n.locale, label: this.$t('settings.onboarding.name'), class: 'col-width-xl', filterKey: 'name' },
        { key: 'params', label: this.$t('settings.onboarding.params'), class: 'col-width-xl' },
        { key: 'order', label: this.$t('settings.onboarding.order'), class: 'col-width-xl' }
      ];
      const actions = [];
      if (this.canEdit) {
        actions.push({ label: this.$t('settings.onboarding.edit'), emit: 'editItem', class: 'btn-warning btn-sm', bicon: 'pencil-fill' });
      }
      if (actions) {
        headers.push({ key: 'actions', label: '', actions: actions, class: 'col-width-medium' });
      }
      return headers;
    },
    requestPath () {
      const path = 'config/onboarding/items/?perPage=' + this.paging.limit + '&page=' + this.paging.page;
      return this.ApiRequest.addGetParamsToPath(
        path,
        (this.$refs.tableview ? this.$refs.tableview.getFilterValues() : this.filterValues),
        true
      );
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-onboarding-settings');
    },
    tableFilterConfig () {
      const filters = {};
      filters.name = { type: 'text', label: 'name', colOnlyFilter: true };
      return filters;
    }
  },
  methods: {
    clearFilters () {
      this.filterValues = this.BasicHelper.cloneObject(defaultFilterValues);
      this.getTableData();
    },
    editItem (el) {
      this.$refs.editElFrm.show(el);
    },
    getTableData () {
      this.isLoading = false;
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.isLoading = true;
      this.$forceUpdate();
      this.currentReq = this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_GET, [], (response) => {
        if (response.data) {
          this.tableItems = response.data;
          this.paging = response.paging;
          this.isLoading = false;
        }
      });
    },
    changePage (pageNr) {
      this.paging.page = pageNr;
      this.getTableData();
    }
  },
  mounted () {
    this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    this.getTableData();
    this.isMounted = true;
  }
}
